// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-7b9f10ff] {\n  display: flex;\n}\n.right > div[data-v-7b9f10ff] {\n    margin-right: 0.1rem;\n}\n.dayList[data-v-7b9f10ff] {\n  height: 0.32rem;\n  margin-top: 0.1rem;\n}\n", ""]);
// Exports
module.exports = exports;
